import { Hip3ApiError } from "@/api/hip3";

export function isAnalyticsUnavailable(error: unknown): boolean {
  return error instanceof Hip3ApiError && error.status === 503;
}

export function getErrorMessage(error: unknown, fallback = "Something went wrong"): string {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === "string") {
    return error;
  }
  return fallback;
}
